import { Skeleton } from '@acast-tech/decibel';

const Loader = () => (
  <div data-testid="loader">
    <Skeleton width={30} />
    <Skeleton width={50} />
    <Skeleton width={40} />
  </div>
);

export default Loader;
